export function emojiGQLFields() {
    return `
    __typename
    id
    text
  `;
}
